import Vue from 'vue';
import Router from 'vue-router';

import { AuthRouter, AuthFilter } from '@/assets/src/routers/auth_router';
import ConsoleRouter from '@/assets/src/routers/console_router';
import ROUTE_NAMES from '@/assets/src/routes';

Vue.use(Router);

const router = new Router({
  routes: [
    AuthRouter,
    ConsoleRouter,
    {
      path: '/',
      redirect: { name: ROUTE_NAMES.FIND_USER },
    },
    {
      path: '*',
      name: ROUTE_NAMES.NOT_FOUND,
      component: () => import(/* webpackChunkName: "NotFound" */ '@/views/NotFound.vue'),
    },
  ],
});

router.beforeEach(AuthFilter);

export default router;
